import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default {
  root: {
    position: 'relative',
    selectors: {
      '& > .is-disabled > .ms-Dropdown-titleIsPlaceHolder': {
        backgroundColor: `${theme.palette.neutralLighter} !important`,
        font: theme.palette.neutralTertiary,
      },
      '& > [role=alert]': {
        color: theme.palette.accentError,
      },
      // callout hover
      '&.ms-Dropdown-container > .ms-Stack > .ms-TooltipHost > .ms-Button:hover': {
        color: theme.palette.themePrimary,
      },
      '&.ms-Dropdown-container > .ms-Stack': {
        display: 'block',
        marginBottom: pxToRem(4),
      },
      '&.ms-Dropdown-container > .ms-Stack > .ms-Label': {
        display: 'inline',
      },
    },
  },
  label: {
    selectors: {
      '&::after': {
        color: theme.palette.accentError,
      },
    },
  },
  asterisk: {
    root: {
      color: theme.palette.accentError,
      paddingLeft: pxToRem(5),
      fontWeight: 400,
    },
  },
  dropdown: {
    borderColor: `${theme.palette.neutralTertiary} !important`,
    selectors: {
      '&.is-disabled .ms-Dropdown-title': {
        backgroundColor: `${theme.palette.neutralLighter}`,
      },
      '& > .ms-Dropdown-titleIsPlaceHolder': {
        backgroundColor: theme.palette.neutralWhite,
        borderColor: theme.palette.neutralTertiary,
        color: theme.palette.neutralSecondary,
        fontWeight: 400,
      },
      '& > .ms-Dropdown-titleIsPlaceHolder:focus': {
        borderColor: theme.palette.neutralDark,
      },
      '& > .ms-Dropdown-titleIsPlaceHolder:hover': {
        borderColor: theme.palette.themeDarkerAlt,
      },
      '& > .ms-Dropdown-titleIsPlaceHolder:after': {
        borderColor: theme.palette.themeDarker,
      },
      '& > .ms-Dropdown-title': {
        backgroundColor: theme.palette.neutralWhite,
        borderColor: theme.palette.neutralTertiary,
        fontWeight: 400,
      },
      '& > .ms-Dropdown-title--hasError': {
        borderColor: theme.palette.accentError,
      },
    },
  },
  dropdownItem: {
    backgroundColor: theme.palette.neutralWhite,
    fontWeight: 400,
  },
  dropdownItems: {
    selectors: {
      '& .ms-Dropdown-item:hover': {
        backgroundColor: `${theme.palette.neutralQuaternary} !important`,
      },
    },
  },
  dropdownHeight: {
    calloutMaxHeight: 540,
  },
};
